quoteModule.factory('quoteSaveRequestMapper',
    ['$window', 'erateSessionVarsService','imSessionVarsService','rateQuoteCoordService',
        'DealInfo', 'financeService',
    function ($window, erateSessionVarsService, imSessionVarsService, rateQuoteCoordService,
              DealInfo, financeService) {
        var quoteSaveRequestMapper = {};

        var privateFormatDateYYYYMMDD = function(dt){
            //Splitting the date to get day instead of using ('0' + dt.getUTCDate()).slice(-2) which is dependent
            //on timezoneoffset and causes the incorrect day to be returned based on time of day
            var date = dt.toString().split(" ");
            var day = dt.getDate();
            var month = ('0' + (dt.getMonth() + 1)).slice(-2);
            var year = dt.getFullYear();

            return year + '-' + month + '-' + day;
        }

        quoteSaveRequestMapper.mapAllDataToSaveRequestObject = function(
            quoteSvRequest, scenarioId, vehicleData, dealData, customerData, lenderData, partnerSpecificFields)
        {
            //"map" the data to the save template
            quoteSvRequest.applicationPartnerCode = imSessionVarsService.getCurrentProviderCode();
            var dos = privateFormatDateYYYYMMDD(vehicleData.dateOfSale);
            quoteSvRequest.dateOfSale = dos;//getting rid of time zone info
            quoteSvRequest.dealershipAccountCode = erateSessionVarsService.getCurrentDealerAccountCode();
            quoteSvRequest.tlApplication = 'TLCOMMERCE';
            quoteSvRequest.quoteScenarioId = scenarioId;
            quoteSvRequest.quoteSessionId = rateQuoteCoordService.getQuoteSessionId().toString();
            quoteSvRequest.vehicleCertification = vehicleData.vehicleCert;
            quoteSvRequest.vehicleOdometer = parseInt(vehicleData.odometer);
            quoteSvRequest.vehicleToRate.InternalVINId = vehicleData.vin;
            quoteSvRequest.vehicleToRate.Make.InternalMakeId = vehicleData.makeId;
            quoteSvRequest.vehicleToRate.Make.MakeName = vehicleData.makeName;
            quoteSvRequest.vehicleToRate.Model.InternalModelId = vehicleData.modelId;
            quoteSvRequest.vehicleToRate.Model.SeriesName = vehicleData.modelName;
            quoteSvRequest.vehicleToRate.ModelYear = (!vehicleData.year ? 0 : parseInt(vehicleData.year));
            quoteSvRequest.vehicleToRate.OriginalVehicleIdentification = vehicleData.vin;
            var inservice = vehicleData.inService ? privateFormatDateYYYYMMDD(vehicleData.inService) : "1900-01-01";
            quoteSvRequest.vehicleInservice = inservice;
            quoteSvRequest.vehicleUsageTypes = vehicleData.vehicleUsage;
            if (dealData == null)
                dealData = new DealInfo();
            quoteSvRequest.vehicleFinancials.AmountFinanced = dealData.amountFinanced == undefined || dealData.amountFinanced == '' ? 0.00 : parseFloat(dealData.amountFinanced).toFixed(2);
            quoteSvRequest.vehicleFinancials.DMSDealNumber = dealData.dmsDealNumber;
            quoteSvRequest.vehicleFinancials.DaysToFirstPayment = parseInt(dealData.daysToFirst);
            if (dealData.isLeaseMoneyFactor) {
                quoteSvRequest.vehicleFinancials.MoneyFactor = parseFloat(dealData.financeRate);
            }
            else {
                quoteSvRequest.vehicleFinancials.FinancedAPR = parseFloat(dealData.financeRate);
            }
            quoteSvRequest.vehicleFinancials.FinancedTermMonths = parseInt(dealData.termMonths);
            quoteSvRequest.vehicleFinancials.FirstPaymentDate = dealData.firstPaymentDate;
            quoteSvRequest.vehicleFinancials.MSRP = parseFloat(dealData.MSRP).toFixed(2);
            quoteSvRequest.vehicleFinancials.PurchasePrice = dealData.sellingPrice == undefined || dealData.sellingPrice == '' ? 0.00 : parseFloat(dealData.sellingPrice).toFixed(2);
            quoteSvRequest.vehicleFinancials.StockNumber = dealData.stockNumber;
            quoteSvRequest.vehicleFinancials.VehicleSaleType = dealData.saleType;

            quoteSvRequest.vehicleFinancials.LenderCode = lenderData && lenderData.code ? lenderData.code : null;
            quoteSvRequest.vehicleFinancials.LenderName = lenderData && lenderData.name ? lenderData.name : lenderData ? lenderData : null;
            quoteSvRequest.vehicleFinancials.LenderAddress1 = lenderData && lenderData.address1 ? lenderData.address1 : null;
            quoteSvRequest.vehicleFinancials.LenderAddress2 = lenderData && lenderData.address2 ? lenderData.address2 : null;
            quoteSvRequest.vehicleFinancials.LenderCity = lenderData && lenderData.city ? lenderData.city : null;
            quoteSvRequest.vehicleFinancials.LenderState = lenderData && lenderData.state ? lenderData.state : null;
            quoteSvRequest.vehicleFinancials.LenderZip = lenderData && lenderData.zip ? lenderData.zip : null;

            quoteSvRequest.customerInformation.BusinessName = customerData.BusinessInfo.businessName;
            quoteSvRequest.customerInformation.BuyerEmail = customerData.BuyerInfo.email;
            quoteSvRequest.customerInformation.BuyerFirstName = customerData.BuyerInfo.firstName;
            quoteSvRequest.customerInformation.BuyerMiddleName = customerData.BuyerInfo.middleName;
            quoteSvRequest.customerInformation.BuyerLastName = customerData.BuyerInfo.lastName;
            quoteSvRequest.customerInformation.CoBuyerEmail = customerData.CoBuyerInfo.email;
            quoteSvRequest.customerInformation.CoBuyerFirstName = customerData.CoBuyerInfo.firstName;
            quoteSvRequest.customerInformation.CoBuyerMiddleName = customerData.CoBuyerInfo.middleName;
            quoteSvRequest.customerInformation.CoBuyerLastName = customerData.CoBuyerInfo.lastName;
            quoteSvRequest.customerInformation.CustomerAddressLine1 = customerData.address1;
            quoteSvRequest.customerInformation.CustomerAddressLine2 = customerData.address2;
            quoteSvRequest.customerInformation.CustomerPhone1 = customerData.phone1;
            quoteSvRequest.customerInformation.City = customerData.city;
            quoteSvRequest.customerInformation.CustomerPhone2 = customerData.phone2;
            quoteSvRequest.customerInformation.DriverFirstName = customerData.BusinessInfo.driverFirstName;
            quoteSvRequest.customerInformation.DriverLastName = customerData.BusinessInfo.driverLastName;
            quoteSvRequest.customerInformation.State = customerData.state;
            quoteSvRequest.customerInformation.Zip = customerData.zip;

            //push the rates
            quoteSvRequest.Rates = [];
            quoteSvRequest.CachedProductResponseIds = [];
            quoteSvRequest.CachedRateResponseIds = [];

            quoteSvRequest.FinancedRatesInfo = [];

            var svdQuoteId = null;

            var i=0;
            rateQuoteCoordService.getHeldQuotesPerProposal()[scenarioId].forEach(function (nxtQuoteScenarioRate) {
                if (nxtQuoteScenarioRate.cachedProductResponseId){
                    quoteSvRequest.CachedProductResponseIds.push(nxtQuoteScenarioRate.cachedProductResponseId);
                }
                if (nxtQuoteScenarioRate.cachedRateResponseId) {
                    quoteSvRequest.CachedRateResponseIds.push(nxtQuoteScenarioRate.cachedRateResponseId);
                }
                var hld = rateQuoteCoordService.getRateForScenarioCodeProductId(scenarioId,nxtQuoteScenarioRate.RatedProduct.InternalProductId);

                if (hld && hld.RatedTerms[0].SavedRateUniqueId && hld.RatedTerms[0].SavedRateUniqueId.length > 0)
                    nxtQuoteScenarioRate.RatedTerms[0].SavedRateUniqueId = hld.RatedTerms[0].SavedRateUniqueId;
                quoteSvRequest.Rates.push(nxtQuoteScenarioRate);

                svdQuoteId = nxtQuoteScenarioRate.RatedTerms[0].SavedRateUniqueId;

                var financedQuoteInfo = financeService.getFinancedQuoteInfoById(nxtQuoteScenarioRate.RatedTerms[0].SavedRateUniqueId);
                if(financedQuoteInfo && financedQuoteInfo.financingInfo && financedQuoteInfo.financingInfo.accepted) {
                    quoteSvRequest.FinancedRatesInfo.push({
                        SavedRateUniqueId : nxtQuoteScenarioRate.RatedTerms[0].SavedRateUniqueId,
                        MonthlyPayment : financedQuoteInfo.financingInfo.calculatedData.monthlyPayment,
                        FinancingTermMonths : financedQuoteInfo.financingInfo.calculatedData.financingTermMonths,
                        FinancingFeeAmount :  financedQuoteInfo.financingInfo.calculatedData.financingFeeAmount,
                        DownPayment: financedQuoteInfo.financingInfo.downPayment,
                        FinancedAmount: financedQuoteInfo.financingInfo.calculatedData.financedAmount,
                        SalesTaxAmount: financedQuoteInfo.financingInfo.salesTaxNA ? 0 : financedQuoteInfo.financingInfo.salesTaxAmount || 0 ,
                        FLDocFeeStamp: financedQuoteInfo.financingInfo.calculatedData.docFee
                    });
                }

                //Let's package our taxRates/taxAmount relative to product instead of on the quote root
                var integrationData = getIntegrationData();
                if (integrationData && svdQuoteId){
                    var salesTaxRate = null;
                    var copyPartnerSpecificFields = partnerSpecificFields;
                    var flexfields = new Array();
                    if (integrationData.productsToQuote && integrationData.productsToQuote.length > 0){
                        integrationData.productsToQuote.forEach(function(qtData){
                            if (qtData && qtData.internalQuoteId && qtData.internalQuoteId == svdQuoteId &&
                                qtData.salesTaxRate
                            )
                            {
                                flexfields.push(
                                    {
                                        "FieldName" : "salesTaxRate",
                                        "FieldValue" : qtData.salesTaxRate
                                    });
                                flexfields.push(
                                    {
                                        "FieldName" : "salesTaxAmount",
                                        "FieldValue" : qtData.salesTaxAmount
                                    });

                               quoteSvRequest.Rates[i].RatedTerms[0].RatedTerm.PartnerSpecificFields.FlexFields = flexfields.slice(0);

                            }
                        });
                    }
                }
                i=i+1;
            });
            if (quoteSvRequest.CachedProductResponseIds.length == 0)
            {
                quoteSvRequest.CachedProductResponseIds = null;
                quoteSvRequest.CachedRateResponseIds = null;
            }
            if (dealData.salesPersonId){
                partnerSpecificFields.push(
                    {
                        key : "salespersonid",
                        value : dealData.salesPersonId
                    }
                );
            }

            if (vehicleData.vehicleType!=null && vehicleData.vehicleType == 'RV') {
                partnerSpecificFields.push(
                    {
                        key: "rvType",
                        value: vehicleData.rvType
                    }
                );
                partnerSpecificFields.push(
                    {
                        key: "rvManuWarrMonths",
                        value: vehicleData.rvManuMonths
                    }
                );
                partnerSpecificFields.push(
                    {
                        key: "rvManuWarrMiles",
                        value: (vehicleData.rvManuMiles == null ? 0 : vehicleData.rvManuMiles)
                    }
                );
                partnerSpecificFields.push(
                    {
                        key: "rvModelYear",
                        value: vehicleData.year
                    }
                );
            }
            if (customerData.customerNumber){
                partnerSpecificFields.push(
                    {
                        key : "customernumber",
                        value : customerData.customerNumber
                    }
                );
            }
           if (vehicleData.vehicleSaleType){
                partnerSpecificFields.push(
                    {
                        key : "vehicleNewUsed",
                        value : vehicleData.vehicleSaleType
                    }
                );
            }
            // copy the partner fields
            quoteSvRequest.partnerSpecificFields = partnerSpecificFields.slice(0);
        }

        var getIntegrationData = function() {
            return JSON.parse($window.sessionStorage.getItem('SESS_INTEGRATION_PREFILL'));
        }

        return quoteSaveRequestMapper;

    }]);

